import axios from 'axios';

// Get CSRF token only if the element exists.
// Avoid Error:'Cannot read property 'getAttribute' of undefined
// when doing system tests.

const csrfTokenElements = document.getElementsByName('csrf-token');
if (csrfTokenElements.length > 0) {
  const token = csrfTokenElements[0].getAttribute('content');
  axios.defaults.headers.common['X-CSRF-Token'] = token;
}

// accept json response format globally
axios.defaults.headers.common.Accept = 'application/json';

// manage session timeout from front-end
const timeOutInMinutes = 60;
let sessionTimedOut = false;
const timeOutInMilliSeconds = timeOutInMinutes * 60 * 1000 + 60000;

// recursive function: if there is activity (any axios call) reset the counter
// else reload page to ensure devise re-login is executed
(function checkSession() {
  if (sessionTimedOut) {
    axios
      .get('/users/edit.html')
      .then(response => {
        sessionTimedOut = false;
        setTimeout(checkSession, timeOutInMilliSeconds);
      })
      .catch(error => {
        window.location.reload();
      });
  } else {
    sessionTimedOut = true;
    setTimeout(checkSession, timeOutInMilliSeconds);
  }
})();
// ///////////////////////////////////////////////////////

let requestCount = 0;

// intercept request globally
axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    requestCount += 1;
    _updateStoreRequestCounter(requestCount);
    return config;
  },
  error =>
    // Do something with request error
    Promise.reject(error)
);

// intercept response globally
axios.interceptors.response.use(
  response => {
    requestCount--;
    _updateStoreRequestCounter(requestCount);

    // reset the session timeout
    sessionTimedOut = false;
    // do something with response data
    return response;
  },
  error => {
    requestCount--;
    _updateStoreRequestCounter(requestCount);
    // handle unauthorized (401) error globally
    if (error.response.status === 401) {
      // reload page to ensure devise re-login is executed
      window.location.reload();
    }

    // generate a generic error if rootStore is set
    // use setAxiosDefaultErrorHandler() to set the rootStore
    if (axios.rootStore && axios.rootStore.generateAlert) {
      axios.rootStore.generateAlert({
        type: 'danger',
        headline: 'axios_generic_error_alert'
      });
    }

    return Promise.reject(error);
  }
);

const setAxiosRootStoreAlertHandler = rootStore => {
  axios.rootStore = rootStore;
};

const _updateStoreRequestCounter = requestCount => {
  if (axios.rootStore) {
    axios.rootStore.requestCount = requestCount;
  }
};

const AxiosHelpers = {
  // /////////  show alert before closing/updating browser's tab/window  //////
  avoidWindowLeave: () => {
    window.onbeforeunload = () => {
      // if there is any pending request
      if (requestCount > 0) {
        return 'Do you really want to close?';
      }
    };
  }
  // ///////////////////////////////////////////////////////////////////////////
};

AxiosHelpers.avoidWindowLeave();

export { axios as default, setAxiosRootStoreAlertHandler, AxiosHelpers };
